var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 85,
    viewBox: "0 0 85 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.0003 38.3336H58.4003V58.5429L25.9483 23.0002L22.0003 27.3242L54.4523 62.8669H36.0003V69.0002H64.0003V38.3336Z",
    fill: "#B2CE53"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownRight);
export default __webpack_public_path__ + "static/media/DownRight.c298ffeec5ffe6553df8c4aff6e35b4b.svg";
export { ForwardRef as ReactComponent };